module.exports = __webpack_public_path__ + "static/media/BrentNovoselsky.63686ee7.png";